import { useEffect, useState } from 'react'
import { getCompanies, getDesignations } from '../../utils/urls';
import axios from '../../utils/axios'
import { useParams } from 'react-router-dom';
// import CampaignTable from '../../components/campaigns/CampaignTable';
import { useSelector } from 'react-redux'
import GhlUserTable from '../../components/Leaders/GhlUserTable';
import adminLogo from '../../Images/admin_img.jpg'

const Wrapper = () => {
  // const { isLoggedIn, setIsLoggedIn } = useContext(UserIsLoggedIn);
  const { locationId } = useParams();
  const isSuperuser = useSelector((state) => state.user.isSuperuser);
  const image = useSelector((state) => state.user.image);
  const userId = useSelector((state) => state.user.userId);
  const [designationList, setDesignationList] = useState([])
  const [companiesList, setCompaniesList] = useState([])

  const getAllDesignations = () => {
    const url = `${getDesignations}`
    axios.get(url, {
      headers: { 'Content-Type': 'application/json' }
    })
      .then((response) => {
        if (response.status === 200) {
          // console.log(response.data)
          setDesignationList(response.data)

        }
      })
      .catch((error) => {
        // setAppLeads(null)
      })
  }

  const getAllCompanies = () => {
    const url = `${getCompanies}`
    axios.get(url, {
      headers: { 'Content-Type': 'application/json' }
    })
      .then((response) => {
        if (response.status === 200) {
          // console.log(response.data)
          setCompaniesList(response.data)
          // setLoading(false)
        }
      })
      .catch((error) => {
        // setLoading(false)
      })
  }

  useEffect(() => {
    getAllDesignations()
    getAllCompanies()
  }, [userId])

  return (
    <>
      <div
        className='table-container'
        style={{
          paddingBottom: '2rem',
          backgroundImage: `url("${isSuperuser ? adminLogo : image}")`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          minHeight: '90vh',
          position: 'relative' // Needed for overlay positioning
        }}
      >
        <div
          className='table-inner-div'
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            zIndex: 0 // Below content
          }}
        />
        <GhlUserTable designationList={designationList} companiesList={companiesList} />
      </div>
    </>
  );
}
export default Wrapper;